/**
 * Pure lon/lat placement for the OSM minimap's turbine and viewpoint
 * markers (issue #75): converts the local-metre entities already built by
 * turbineEntities/viewpointEntities (ui/minimap.ts) to WGS84 via
 * osmProjection.ts. Leaflet-free so it's testable in plain Node, mirroring
 * the minimapLabels.ts pure-geometry / osmMinimap.ts Leaflet-wrapper split.
 * Orientation aid only (hard constraint #1) — never read by raypath/, never
 * affects any LOS result.
 */
import { localToLonLat } from './osmProjection';

export interface MarkerPoint {
  lon: number;
  lat: number;
  label: string;
}

export interface ViewpointMarkerPoint extends MarkerPoint {
  id: string;
}

/** Turbine (or any label-only) entities -> WGS84 marker points. */
export function toMarkerPoints(entities: Array<{ x: number; z: number; label: string }>): MarkerPoint[] {
  return entities.map((e) => {
    const { lon, lat } = localToLonLat(e.x, e.z);
    return { lon, lat, label: e.label };
  });
}

/** Viewpoint entities -> WGS84 marker points, keeping the id so a marker
 * click can drive the same jump path as the viewpoint dropdown. */
export function toViewpointMarkerPoints(
  entities: Array<{ id: string; x: number; z: number; label: string }>,
): ViewpointMarkerPoint[] {
  return entities.map((e) => {
    const { lon, lat } = localToLonLat(e.x, e.z);
    return { lon, lat, label: e.label, id: e.id };
  });
}
